import axiosInstance from "../../../utils/axios";
import { objToURL } from "../../../utils/commonfunction";
import { ROLE } from "../../../utils/Constants";

const options = { role: ROLE.SUPER_ADMIN };
const path = "admin/cms/agreements";

export const getPlaceholders = async () => {
    return await axiosInstance(options).get(`${path}/placeholders`);
};

export const listTemplates = async (params) => {
    return await axiosInstance(options).get(`${path}/templates${objToURL(params || {})}`);
};

export const getTemplateById = async (id) => {
    return await axiosInstance(options).get(`${path}/templates/${id}`);
};

export const createTemplate = async (values) => {
    return await axiosInstance(options).post(`${path}/templates`, values);
};

export const updateTemplate = async (id, values) => {
    return await axiosInstance(options).put(`${path}/templates/${id}`, values);
};

export const deleteTemplate = async (id) => {
    return await axiosInstance(options).delete(`${path}/templates/${id}`);
};

export const listClubDocuments = async (params) => {
    return await axiosInstance(options).get(`${path}/club-documents${objToURL(params || {})}`);
};

export const generateAgreementForClub = async (values) => {
    return await axiosInstance(options).post(`${path}/generate`, values);
};

export const uploadTemplateFile = async (formData) => {
    return await axiosInstance(options).post(`${path}/upload-template`, formData, {
        headers: {
            "Content-Type": "multipart/form-data"
        }
    });
};

export const bulkDeleteTemplates = async (ids) => {
    return await axiosInstance(options).post(`${path}/templates/bulk-delete`, { ids });
};

export const deleteClubDocument = async (id) => {
    return await axiosInstance(options).delete(`${path}/club-documents/${id}`);
};

export const bulkDeleteClubDocuments = async (ids) => {
    return await axiosInstance(options).post(`${path}/club-documents/bulk-delete`, { ids });
};

